// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__FIjk3","content":"styles_content__UJ32R","projects":"styles_projects__uSEPF"};